// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__a25pj","error":"Textarea_error__35QiC","readonly":"Textarea_readonly__2ZlMe","disabled":"Textarea_disabled__w_6pv"};